const TotalField = (props) => <div>{props.total}</div>;

export default TotalField;
